import { useMobileOrientation } from "react-device-detect";
import { useTranslation } from "react-i18next";

interface ComparisonLegendProps {
  artistName: string;
}
const ComparisonLegend: React.FC<ComparisonLegendProps> = (props) => {
  const { t } = useTranslation("radar");
  const { artistName } = props;
  const { isPortrait } = useMobileOrientation();

  return (
    <div
      className="legenda"
      style={{
        justifyContent: "space-around",
        width: "100%",
        flexDirection: isPortrait ? "column" : "row",
        alignItems: isPortrait ? "flex-start" : "center",
      }}
    >
      <div style={{ display: "flex", alignItems: "center" }}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <span className="label">
            <span
              className="square"
              style={{
                backgroundColor: "#6998F7",
                fontWeight: 400,
              }}
            >
              &nbsp;&nbsp;&nbsp;&nbsp;
            </span>
            {t("pages.CareerDiagnose.artistDiagnose", { artistName })}
          </span>
        </div>
      </div>
      <div style={{ display: "flex", alignItems: "center" }}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <span className="label">
            <span
              className="square"
              style={{
                backgroundColor: "#68D9AC",
                fontWeight: 400,
              }}
            >
              &nbsp;&nbsp;&nbsp;&nbsp;
            </span>
            {t("pages.CareerDiagnose.minimumRequired")}
          </span>
        </div>
      </div>
    </div>
  );
};

export default ComparisonLegend;
